var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mb-8"},[_c('ViewHeader',{attrs:{"title":_vm.$t('message.reviewBooster.title')}}),_c('v-card',{staticClass:"card-rounded card"},[_c('ReviewBoosterConfigEmpty')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }